/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Forgot_Password_ButtonInputs */



/**
* | output |
* | --- |
* | "Forgot Password?" |
*
* @param {Login_Forgot_Password_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_forgot_password_button = /** @type {((inputs?: Login_Forgot_Password_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Forgot_Password_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mot de passe oublié ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Passwort vergessen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ha dimenticato la password?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Забыли пароль?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Has olvidado tu contraseña?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("忘记密码？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードをお忘れですか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पासवर्ड भूल गए?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esqueceu sua senha?")
	return /** @type {LocalizedString} */ ("Forgot Password?")
});